import useMediaQuery from './use-media-query'

export default useMediaQuery
